import {
  GET_REFER_DETAIL_FAILED,
  GET_REFER_DETAIL_SUCCEEDED,
  GET_REFER_LIST,
  GET_REFER_LIST_FAILED,
  GET_REFER_LIST_SUCCEEDED,
  REFER_PAYMENT_REQUEST,
  REFER_PAYMENT_REQUEST_FAILED,
  REFER_PAYMENT_REQUEST_SUCCEEDED,
  REFER_PAYOUT_REQUEST,
  REFER_PAYOUT_REQUEST_FAILED,
  REFER_PAYOUT_REQUEST_SUCCEEDED,
} from '../actions';
import { IRefer } from '../interfaces/refer';
import { getLocalStore } from 'next-persist';

const initialState: IRefer = {
  refer: {
    data: [],
    loading: false,
    total: 0,
  },
  payoutRequestStatus: '',
  paymentRequestStatus: '',
  referDetail: {
    data: {},
  },
};
const persistedState = getLocalStore('referReducer', initialState);

const referReducer = (state = persistedState, action) => {
  switch (action.type) {
    case GET_REFER_LIST:
      return {
        ...state,
        refer: {
          ...state.refer,
          loading: true,
        },
      };
    case GET_REFER_LIST_SUCCEEDED:
      return {
        ...state,
        refer: {
          data: action.data,
          loading: false,
        },
      };
    case GET_REFER_LIST_FAILED:
      return {
        ...state,
        refer: {
          ...state.refer,
          loading: false,
        },
      };

    case REFER_PAYOUT_REQUEST:
      return {
        ...state,
        payoutRequestStatus: 'request',
      };
    case REFER_PAYOUT_REQUEST_SUCCEEDED:
      return {
        ...state,
        payoutRequestStatus: 'success',
      };
    case REFER_PAYOUT_REQUEST_FAILED:
      return {
        ...state,
        payoutRequestStatus: 'failure',
      };

    case REFER_PAYMENT_REQUEST:
      return {
        ...state,
        paymentRequestStatus: 'request',
      };
    case REFER_PAYMENT_REQUEST_SUCCEEDED:
      return {
        ...state,
        paymentRequestStatus: 'success',
      };
    case REFER_PAYMENT_REQUEST_FAILED:
      return {
        ...state,
        paymentRequestStatus: 'failure',
      };

    case GET_REFER_DETAIL_SUCCEEDED:
      return {
        ...state,
        referDetail: {
          data: action.data,
        },
      };
    case GET_REFER_DETAIL_FAILED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};

export default referReducer;
